import Hero from '../components/Workwear/Hero';
import WorkwareCategories from '../components/Workwear/WorkwareCategories';
import GetUpGetItDone from '../components/Workwear/GetUpGetItDone';
import AboutVideoBanner from '../components/Workwear/AboutVideoBanner';
import LimitedEdition from '../components/Workwear/LimitedEdition';
import TraditionAndInnovation from '../components/Workwear/TraditionAndInnovation';
import MostSellingWorkwear from '../components/Home/MostSellingWorkwear';

const Workwear = () => {
  return (
    <div className="">
      <Hero />
      <WorkwareCategories />
      <GetUpGetItDone />
      <AboutVideoBanner />
      <LimitedEdition />
      <TraditionAndInnovation />
      <MostSellingWorkwear />
    </div>
  );
};

export default Workwear;
